/**
 * Append the sharer's referral tag (ref=<userId>) to an outgoing share URL.
 *
 * Any signup that lands through the link then credits both families with the
 * referral bonus (useReferralCapture picks the ref up on page load). No-ops
 * when signed out, on malformed URLs, or when a ref is already present —
 * never forward someone else's ref.
 */
export function withReferral(url, userId) {
  if (!url || !userId) return url;
  try {
    const parsed = new URL(url, window.location.origin);
    if (!parsed.searchParams.has("ref")) {
      parsed.searchParams.set("ref", String(userId).toLowerCase());
    }
    return parsed.toString();
  } catch {
    return url;
  }
}
